import { useMutation, useQueryClient } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'
import { StaffRole } from './types'
import { Staff } from './useCurrentUser'

interface AccountCreateResponse {
  staff: Staff
}

interface AccountCreateBody {
  firstName: string
  lastName: string
  email: string
  type: StaffRole
  password: string
  npi?: string
  subscriptionPlan?: string
  needsVerify?: boolean
  is_admin?: boolean
  activated?: boolean
  additional_data?: Record<string, unknown>
  sponsor_id?: string
  consents?: string[]
  consent_form_version?: string
}

const useCreateAccount = () => {
  const queryClient = useQueryClient()
  const currentSite = useCurrentSite()
  const siteId = currentSite?.id
  const url = '/impacts/staffs'

  return useMutation((vars: AccountCreateBody) =>
    request
      .post<AccountCreateResponse>(url, {
        ...vars,
        subscriptionPlan: vars.subscriptionPlan
          ? vars.subscriptionPlan
          : undefined,
      })
      .then((r) => {
        if (vars.needsVerify) {
          // For registration, we don't have a siteId yet, so skip these cache invalidations
          queryClient.invalidateQueries(QueryKeys.productsAvailable())
        } else if (siteId) {
          // For staff creation with existing site, invalidate site-specific queries
          queryClient.invalidateQueries(QueryKeys.staffs(siteId))
          queryClient.invalidateQueries(QueryKeys.productsAvailable())
        }
        return r.data
      }),
  )
}

export default useCreateAccount
